import Model from 'flarum/common/Model';
export default class BlogMeta extends Model {
  discussion() {
    return Model.hasOne('discussion').call(this);
  }
  featuredImage() {
    return Model.attribute('featuredImage').call(this);
  }
  summary() {
    return Model.attribute('summary').call(this);
  }
  isFeatured() {
    return Model.attribute('isFeatured').call(this);
  }
  isSized() {
    return Model.attribute('isSized').call(this);
  }
  isPendingReview() {
    return Model.attribute('isPendingReview').call(this);
  }
}
flarum.reg.add('fof-blog', 'common/models/BlogMeta', BlogMeta);